export const ConvertDateToJalali = (date) => {
  const jalali = new Intl.DateTimeFormat("fa-u-ca-persian-nu-latn", {
    dateStyle: "short",
  }).format(date);
  return jalali;
};
